import styles from './NavigationTouchBackdrop.module.css';

/**
 * Touch backdrop for navigation
 * @param {object} props
 * @param {() => void} props.onClick - Function called on click
 * @param {string} [props.className] - Additional CSS classes
 * @param {React.ReactNode} [props.children = null] - Backdrop content
 * @param {boolean} [props.isDisplayed] - Whether the backdrop is displayed
 * @returns {React.ReactNode}
 */
function NavigationTouchBackdrop({
  onClick, isDisplayed, className = '', children = null,
}) {
  return (
    <button
      type="button"
      className={`${styles['touch-backdrop']} 
        ${isDisplayed ? styles['is-displayed'] : ''} ${className}`}
      onClick={onClick}
      aria-label="Open/close navigation"
    >
      {children}
    </button>
  );
}

export default NavigationTouchBackdrop;
